// extracted by mini-css-extract-plugin
export default {"info":"styles_info__UdqMr","names":"styles_names__G4Qc8","address":"styles_address__ObzIR"};